import { toast } from "sonner";

/**
 * How a catalogue screen says something worked.
 *
 * SMALLER THAN IT FIRST WAS, because writing the call sites showed most of it
 * was already handled. An earlier version wrapped failures too, on the argument
 * that screens throwing away the server's reason replace it with "Could not
 * save" -- but `apps/admin/src/lib/api-client.ts` already toasts the server's
 * message for every failed request, globally, which is why the product editor
 * and the create screen deliberately toast nothing on error and say so in their
 * own comments. A second error path would have produced TWO toasts for one
 * failure, which is worse than the inconsistency it claimed to fix.
 *
 * What is left is the half that was genuinely per-screen: the wording of
 * success. Past tense, naming what happened -- "Product published", not
 * "Success" and not "Saving...". A toast arrives after the fact, and one that
 * says "Success" leaves an operator who clicked two things wondering which.
 */
/**
 * The second line, for the detail that does not belong in the headline.
 *
 * ADDED BECAUSE ITS ABSENCE WAS THE REASON THE CONVENTION DID NOT TAKE. Four
 * call sites in the import screens needed a description, `notify` could not
 * express one, and reaching past it to `sonner` for them brought the error-toast
 * mistake along on five more. A convention that cannot say what the screens
 * need to say is a convention that gets bypassed.
 */
interface NotifyOptions {
	description?: string;
}

export const notify = {
	/** Past tense, and name the thing: "Brand withdrawn", "3 products published". */
	done(message: string, options?: NotifyOptions): void {
		toast.success(message, options);
	},

	/**
	 * Something happened that is not a failure but is not what was asked for --
	 * a bulk action that skipped rows, a save that was a no-op. Distinct from
	 * `done` because an operator who reads only the colour should still stop.
	 */
	partly(message: string, options?: NotifyOptions): void {
		toast.warning(message, options);
	},
};
